import { Box, Button, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as htmlToImage from "html-to-image";
import { useRef, useContext } from "react";
import ProfileAvatar from "../ProfileAvatar";
import { GlobalContext } from "../Context";
import { useTranslation } from "react-i18next";
import { orange, blue, purple, green } from "../../../theme/colours";
import { TRYP_SVGS } from "../../../constants";

const DownloadModal = ({ stats, open, setOpen }) => {
  const { t } = useTranslation(["Profile", "ScoreCategories"]);
  const { userState, mobileView, tabletView, desktopView } =
    useContext(GlobalContext);

  const modalBoxStyle = {
    maxWidth: tabletView ? "25rem" : mobileView ? "21rem" : "100vw",
    width: !mobileView && !tabletView ? "1200px" : "auto",
    maxHeight: tabletView ? "85vh" : mobileView ? "95vh" : "22.5rem",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    background:
      mobileView || tabletView
        ? "linear-gradient(to bottom, #D4CBE9, #EFECF8)"
        : "linear-gradient(to right, #F0EBFC, #F3F1F8)",
    borderRadius: "5px",
    overflow: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  };
  const buttonStyle = {
    m: "0.25rem",
    mL: "auto",
  };
  const iconStyle = { fontSize: "1rem" };
  const iconBox = {
    display: "flex",
    flexDirection: !mobileView && !tabletView && "column",
  };
  const avatarStyle = {
    display: "flex",
    flexDirection: !mobileView && !tabletView && "column",
    justifyContent: "center",
    alignItems: mobileView || tabletView ? "flex-end" : "center",
    p: "0 2rem 2rem",
    height: "100%",
  };
  const avatarTextStyle = {
    "& h3": { fontSize: "1.125rem" },
    "& > h3:last-child": {
      mt: "0.5rem",
    },
    ...((mobileView || tabletView) && {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      m: "0 0 2.25rem 1.5rem",
    }),
  };
  const statStyles = {
    position: mobileView && "relative",
    display: "flex",
    flexDirection: (mobileView || tabletView) && "column",
    p: mobileView ? "1rem 2rem" : "0rem",
    background:
      mobileView || tabletView
        ? "linear-gradient(to bottom, #D4CBE9, #EFECF8)"
        : "linear-gradient(to right, #F0EBFC, #F3F1F8)",
    height: mobileView || tabletView ? "inherit" : "22.5rem",
  };
  const statGroupStyle = {
    display: "flex",
    flexWrap: "wrap",
    height: "fit-content",
    p: mobileView ? "1rem 2rem 0 0" : tabletView && "0 0 2rem 0",
    "& > *": {
      width: "100%",
    },
    "& img": {
      height: mobileView || tabletView ? "auto" : "3.5rem",
      width: mobileView || tabletView ? "2rem" : "auto",
      margin: mobileView || tabletView ? "auto 0.75rem" : "0 auto 1rem",
    },
    "& h3": {
      p: "0.75rem",
      borderRadius: "5px",
      width: mobileView || tabletView ? "100%" : "auto",
    },
    "& p": {
      p: "0 0.75rem",
      mt: "0.75rem",
      ml: (mobileView || tabletView) && "auto",
      fontWeight: 500,
      fontSize: "1rem",
      display: "flex",
      justifyContent: "space-between",
      width: mobileView || tabletView ? "calc(100% - 3.5rem)" : "100%",
      "& span": {
        fontWeight: 800,
      },
    },
    width: mobileView ? "100%" : tabletView ? "70%" : "22.5%",
  };
  const userScoreStyle = {
    display: "flex",
    flexDirection: (mobileView || tabletView) && "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    pt: !mobileView && "2rem",
    pb: !mobileView && !tabletView && "2rem",
  };
  const nameStyle = {
    textAlign: "left",
  };
  const userNameStyle = {
    ...nameStyle,
    m: !mobileView && !tabletView && "1rem 0 0.5rem",
  };
  const userLevelStyle = {
    ...nameStyle,
    fontWeight: 600,
    textAlign: "center",
  };
  const closeButtonStyle = {
    display: "flex",
    justifyContent: "flex-end",
    position: "absolute",
    zIndex: 1,
    ...(desktopView
      ? {
          right: 0,
        }
      : {
          left: "80%",
          bottom: "93%",
        }),
  };
  const avatarAreaStyle = {
    borderRadius:
      mobileView || tabletView ? "0 0 290px 300px" : "0 250px 250px 0",
    width: tabletView ? "40rem" : mobileView ? "35rem" : "30%",
    background: `linear-gradient(180deg, ${green[3]} 55%, ${purple[2]} 100%)`,
    height: "30rem",
    transform: tabletView
      ? "translateX(-19%) translateY(-55%)"
      : mobileView
      ? "translateX(-27%) translateY(-65%)"
      : "translateY(-9%)",
    mb: tabletView ? "-18rem" : mobileView ? "-20rem" : "0",
  };
  const iconAreaStyle = {
    height: "1.5rem",
    transform: "scale(3)",
  };
  const statsBtnStyle = {
    display: "flex",
    justifyContent: "space-between",
    borderRadius: "5px",
    ml: (mobileView || tabletView) && "1rem",
    height: mobileView || tabletView ? "3rem" : "inherit",
    width: "100%",
  };
  const cardIconStyle = {
    height: "4.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: mobileView || tabletView ? "3.5rem" : "100%",
    "& svg *": {
      width: "5rem",
      height: "5rem",
    },
  };
  const focusIconStyle = {
    "& svg *": {
      fill: blue[1],
    },
  };
  const handlingIconStyle = {
    "& svg *": {
      fill: orange[1],
    },
  };
  const ecoIconStyle = {
    "& svg *": {
      fill: purple[1],
    },
  };
  const downloadButtonStyle = {
    width: "100%",
    position: desktopView ? "absolute" : "relative",
    bottom: "0",
  };

  const dataRef = useRef();

  const saveAs = (blob, fileName) => {
    var elem = window.document.createElement("a");
    elem.href = blob;
    elem.download = fileName;
    elem.style = "display:none;";
    (document.body || document.documentElement).appendChild(elem);
    if (typeof elem.click === "function") {
      elem.click();
    } else {
      elem.target = "_blank";
      elem.dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
        }),
      );
    }
    URL.revokeObjectURL(elem.href);
    elem.remove();
  };

  const handleDownload = () => {
    htmlToImage
      .toPng(dataRef.current)
      .then(function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        document.body.appendChild(img);
        saveAs(dataUrl, `${userState.fn}${userState.ln}-playerCard.png`);
        document.body.removeChild(img);
      })
      .catch(function (error) {
        console.error("ERROR IN CAPTURE: " + error);
      });
  };
  const handleClose = () => {
    setOpen(!open);
  };

  return (
    <Modal open={open}>
      <Box sx={modalBoxStyle}>
        <Box sx={closeButtonStyle}>
          <Button sx={buttonStyle} onClick={handleClose}>
            <CloseIcon sx={iconStyle} />
          </Button>
        </Box>
        {/* the license itself. */}
        <Box ref={dataRef}>
          <Box sx={statStyles}>
            <Box sx={avatarAreaStyle}>
              <Box sx={avatarStyle}>
                <ProfileAvatar
                  disableTransform
                  type={userState.avatar}
                  width={"8rem"}
                />
                <Box sx={avatarTextStyle}>
                  <Typography variant="h3" sx={userNameStyle}>
                    {userState.fn} {!tabletView && !mobileView && userState.ln}
                  </Typography>
                  <Typography variant="h3" sx={userLevelStyle}>
                    {t("levelNumber", { level: userState?.level })}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={userScoreStyle}>
              <Box sx={statGroupStyle}>
                <Box sx={iconBox}>
                  <Box sx={{ ...cardIconStyle, ...handlingIconStyle }}>
                    <Box sx={iconAreaStyle}>{TRYP_SVGS["handling"]}</Box>
                  </Box>
                  <Box
                    sx={{
                      ...statsBtnStyle,
                      ...{ backgroundColor: orange[2] },
                    }}>
                    <Typography variant="h3" color={orange[1]}>
                      {t("ScoreCategories:handling")}
                    </Typography>
                    <Typography
                      sx={{ textAlign: (mobileView || tabletView) && "end" }}
                      variant="h3"
                      color={orange[1]}>
                      {stats.handling ? stats.handling : "-"}
                    </Typography>
                  </Box>
                </Box>
                <Typography>
                  {t("ScoreCategories:acceleration")}{" "}
                  <span>{stats.acceleration ? stats.acceleration : "-"}</span>
                </Typography>
                <Typography>
                  {t("ScoreCategories:braking")}{" "}
                  <span>{stats.braking ? stats.braking : "-"}</span>
                </Typography>
                <Typography>
                  {t("ScoreCategories:cornering")}{" "}
                  <span>{stats.cornering ? stats.cornering : "-"}</span>
                </Typography>
              </Box>
              <Box sx={statGroupStyle}>
                <Box sx={iconBox}>
                  <Box sx={{ ...cardIconStyle, ...focusIconStyle }}>
                    <Box sx={iconAreaStyle}>{TRYP_SVGS["focus"]}</Box>
                  </Box>
                  <Box
                    sx={{
                      ...statsBtnStyle,
                      ...{ backgroundColor: blue[3] },
                    }}>
                    <Typography variant="h3" color={blue[1]}>
                      {t("ScoreCategories:focus")}
                    </Typography>
                    <Typography
                      sx={{ textAlign: (mobileView || tabletView) && "end" }}
                      variant="h3"
                      color={blue[1]}>
                      {stats.focus ? stats.focus : "-"}
                    </Typography>
                  </Box>
                </Box>
                <Typography>
                  {t("ScoreCategories:phone")}{" "}
                  <span>{stats.phone ? stats.phone : "-"}</span>
                </Typography>
                <Typography>
                  {t("ScoreCategories:steadiness")}{" "}
                  <span>{stats.steadiness ? stats.steadiness : "-"}</span>
                </Typography>
              </Box>
              <Box sx={statGroupStyle}>
                <Box sx={iconBox}>
                  <Box sx={{ ...cardIconStyle, ...ecoIconStyle }}>
                    <Box sx={iconAreaStyle}>{TRYP_SVGS["eco"]}</Box>
                  </Box>
                  <Box
                    sx={{
                      ...statsBtnStyle,
                      ...{ backgroundColor: purple[3] },
                    }}>
                    <Typography variant="h3" color={purple[1]}>
                      {t("ScoreCategories:eco")}
                    </Typography>
                    <Typography
                      sx={{ textAlign: (mobileView || tabletView) && "end" }}
                      variant="h3"
                      color={purple[1]}>
                      {stats.eco ? stats.eco : "-"}
                    </Typography>
                  </Box>
                </Box>
                <Typography>
                  {t("ScoreCategories:speed")}{" "}
                  <span>{stats.speed ? stats.speed : "-"}</span>
                </Typography>
                <Typography>
                  {t("ScoreCategories:swerve")}{" "}
                  <span>{stats.swerve ? stats.swerve : "-"}</span>
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Button sx={downloadButtonStyle} onClick={handleDownload}>
          {t("downloadPlayerData")}
        </Button>
      </Box>
    </Modal>
  );
};

export default DownloadModal;
